import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'openingTitle',
		'openingBody',
		'tryNow',
		'copiedTitle',
		'copiedBody',
		'copyAgain',
		'copyFailed',
		'learnMore',
		'close',
		'agentPrompt',
		'promptLabel',
		'opensNewWindow',
	]
> = defineContent({
	default: {
		openingTitle: {
			id: 'puma.jira-mcp-comment-nudge.opening.title',
			defaultMessage: 'Next time, let your agent draft the update.',
			description:
				'Title of a banner under the Jira comment editor, shown after the user adds a comment, suggesting their AI agent drafts the next one',
			role: 'title',
		},
		openingBody: {
			id: 'puma.jira-mcp-comment-nudge.opening.body',
			defaultMessage: 'It pulls in your recent work and Jira context.',
			description: 'Body of the Jira comment agent banner before the user copies the agent prompt',
			role: 'description',
		},
		tryNow: {
			id: 'puma.jira-mcp-comment-nudge.opening.try-now',
			defaultMessage: 'Try now',
			description:
				'Primary button on the Jira comment agent banner that copies a prompt for the agent',
		},
		copiedTitle: {
			id: 'puma.jira-mcp-comment-nudge.copied.title',
			defaultMessage: 'Prompt copied.',
			description: 'Title of the Jira comment agent banner after the agent prompt is copied',
		},
		copiedBody: {
			id: 'puma.jira-mcp-comment-nudge.copied.body',
			defaultMessage: 'Paste it into your agent to draft a comment for you to review.',
			description: 'Body of the Jira comment agent banner after the agent prompt is copied',
		},
		copyAgain: {
			id: 'puma.jira-mcp-comment-nudge.copied.copy-again',
			defaultMessage: 'Copy again',
			description: 'Button on the Jira comment agent banner that copies the agent prompt again',
		},
		copyFailed: {
			id: 'puma.jira-mcp-comment-nudge.copy-failed',
			defaultMessage:
				"We couldn't copy the prompt. It's selected below, so you can copy it yourself.",
			description:
				'Shown on the Jira comment agent banner when the browser blocks copying, above a field holding the selected prompt text',
		},
		learnMore: {
			id: 'puma.jira-mcp-comment-nudge.learn-more',
			defaultMessage: 'Learn more',
			description:
				'Link on the Jira comment agent banner to documentation about using Atlassian from other AI tools',
		},
		close: {
			id: 'puma.jira-mcp-comment-nudge.close',
			defaultMessage: 'Close',
			description: 'Accessible label for the icon button that closes the Jira comment agent banner',
		},
		agentPrompt: {
			id: 'puma.jira-mcp-comment-nudge.agent-prompt',
			defaultMessage:
				'Draft a Jira comment from my recent work and Jira context. Use Atlassian MCP to read what you are allowed to see. Show me the draft to review before posting anything.',
			description:
				'Prompt the user pastes into their AI agent. Copied to the clipboard, and shown on the banner when copying fails. Atlassian MCP is a product name',
		},
		promptLabel: {
			id: 'puma.jira-mcp-comment-nudge.prompt-label',
			defaultMessage: 'Prompt for your agent',
			description:
				'Accessible label for the read-only field that shows the agent prompt when copying fails',
		},
		opensNewWindow: {
			id: 'puma.jira-mcp-comment-nudge.learn-more.opens-new-window',
			defaultMessage: '(opens new window)',
			description:
				'Screen reader text appended to the Learn more link on the Jira comment agent banner, which opens in a new tab',
		},
	},
});
